import PropTypes from "prop-types";
import React from "react";
import { TextBlock, TextField, DateField, MSpinner } from "components/Shared";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";

const CaseInfo = ({ isFetching, caseInfo }) => {
  if (isFetching) {
    return <MSpinner />;
  }

  const CaseInformation = () => (
    <CardText>
      <TextBlock field="Control #: " placeholder="" styleClass="fieldText-bold" />
      <TextBlock field={caseInfo.controlNumber} /><br />
      <br />
      <TextField field="Status" placeholder="" styleClass="fieldText-bold" />
      <TextField field={caseInfo.primaryStatus} />
      <TextField field={caseInfo.webStatus} />
      <br />
      <TextField field="Survey Type Ordered" placeholder="Survey Type Ordered" styleClass="fieldText-bold" />
      <TextField field={caseInfo.originalInspectionType.name} />
      <TextField field="Current Survey Type" placeholder="Current Survey Type" styleClass="fieldText-bold" />
      <TextField field={caseInfo.currentInspectionType.name} />
      <br />
      <b>Due </b><DateField field={caseInfo.caseDueDate} placeholder="Case Due Date" styleClass="fieldText-bold" /><br />
      <TextBlock field={caseInfo.daysUntilDue} placeholder="Days Until Due" /> Days until Due <br />
      <br />
      <b>Assigned To </b><TextBlock field={caseInfo.inspectorNumber} placeholder="UNASSIGNED" styleClass="fieldText-bold" /><br />
      <TextBlock field={caseInfo.assignedTo} placeholder="Assigned To" /> on <br />
      <DateField field={caseInfo.dateAssigned} placeholder="Date Assigned" /> for $<TextBlock field={caseInfo.inspectorFee} placeholder="Inspector Fee" /> <br />
      <br />
    </CardText>
  );

  return (
    <div className="details-assigned-links">
      <Card className="md-block-centered">
        <CardTitle title="Case Information" />
        <CaseInformation />
      </Card>
    </div>
  );
};

CaseInfo.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  caseInfo: PropTypes.object.isRequired
};

export default CaseInfo;